import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import router from './router';
import { getViewerToken } from '@features/auth/api/authService';
import ErrorPage from '@shared/pages/ErrorPage';
import toast, { Toaster } from 'react-hot-toast';
import { useFontToggle } from '@shared/hooks/useFontToggle';
import LineBrowserNoticeDialog from '@/shared/components/LineBrowserNoticeDialog';
import { LanguageProvider } from '@shared/contexts/LanguageContext';

function App() {
  useFontToggle();

  useEffect(() => {
    // APP 啟動時立即取得 Viewer Token (綁定裝置)
    const initializeAuth = async () => {
      try {
        await getViewerToken();
      } catch (error) {
        console.error('Failed to initialize viewer token:', error);
        // 即使失敗也繼續執行，不阻擋 APP 運作
      }
    };

    initializeAuth();
  }, []);

  return (
    <LanguageProvider>
      <ErrorBoundary FallbackComponent={({ error }) => <ErrorPage error={error} />}>
        <RouterProvider router={router} />
        <LineBrowserNoticeDialog />
        <Toaster position="top-center" />
      </ErrorBoundary>
    </LanguageProvider>
  );
}

export default App;
